// removed by extract-text-webpack-plugin
module.exports = {"text800":"UTUCKmVVSuWtMChzx9EAw","text700":"_2_ZlqDm82LZnQchkcVOi2w","text600":"TB8FWM59RCdHyA2WQ9Kti","text500":"_1TJ28DjO2HYemdezZGLkAs","text400":"MI2KT_1l3m1widT6MXxHZ","text300":"_2ALnh6LTJeaDhDQZT-2EHJ","text200":"_3d5saUmLNL2-JmWM7VjAHP","textParagraph":"Oo02ViywUxMsON6PRohPo","crimp":"_1ibJqF_sTE-49imPLUMy_8","trim":"_3p_l_OJMaXBSKl30dMFc-b","card":"_1igHLmosE4eTzxe7FR2KlV"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/PageWelcome/styles.scss
// module id = 842
// module chunks = 0